import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { ProductIntro } from './components/ProductIntro';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UpsellSection } from './components/UpsellSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
const Divider = () => <div className="w-full max-w-4xl mx-auto px-8" data-id="element-0">
    <div className="h-px w-full bg-gradient-to-r from-transparent via-[#d4af37]/20 to-transparent" data-id="element-1" />
  </div>;
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    fbq('init', '904978025482552');
    // @ts-ignore
    fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-[#0a1628] selection:bg-[#d4af37]/30 selection:text-white overflow-hidden font-sans text-[#e2e8f0]" data-id="element-2">
      {/* Global subtle background gradient */}
      <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#0f1d36] via-[#0a1628] to-[#0a1628] -z-10" data-id="element-3" />

      {/* Meta Pixel Fallback */}
      <noscript data-id="element-4">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1" data-id="element-5" />
      </noscript>

      <HeroSection data-id="element-6" />
      <Divider data-id="element-7" />

      <ProblemSection data-id="element-8" />

      <TruthSection data-id="element-9" />

      <ProductIntro data-id="element-10" />
      <Divider data-id="element-11" />

      <ModulesSection data-id="element-12" />
      <Divider data-id="element-13" />

      <BonusSection data-id="element-14" />
      <Divider data-id="element-15" />

      <ComparisonTable data-id="element-16" />
      <Divider data-id="element-17" />

      <TestimonialsSection data-id="element-18" />

      <UpsellSection data-id="element-19" />

      <PricingSection data-id="element-20" />
      <Divider data-id="element-21" />

      <GuaranteeSection data-id="element-22" />
      <Divider data-id="element-23" />

      <FAQSection data-id="element-24" />
      <Divider data-id="element-25" />

      <FinalCTA data-id="element-26" />

      <SocialProofPopup data-id="element-27" />
    </main>;
}